module.exports = __webpack_public_path__ + "static/media/logo.5ebc0d56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.jpg
// module id = 544
// module chunks = 0